<template>
  <div class="wrapper">
    <top-navbar class="desktop"></top-navbar>    

    <DesktopSideBar class="desktop" v-if="loggedIn"/>

    <div class="main-panel" :style="loggedIn ? 'width: calc(100% - 3.5em)' : 'width: 100%;'" v-if="window>=990">            
      <dashboard-content @click="toggleSidebar"> </dashboard-content>
      <content-footer></content-footer>
    </div>

    <div class="main-panel-mobile" v-if="window<990">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar"> </dashboard-content>
      <content-footer></content-footer>
    </div>

  </div>
</template>
<style lang="scss">
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}
</style>
<script>
import DashboardContent from "./Content.vue";
import ContentFooter from "./ContentFooter.vue";
import DesktopSideBar from './DesktopSideBar.vue';
import MobileMenu from "./MobileMenu.vue";
import TopNavbar from "./TopNavbar.vue";

export default {
  meta: [
    { name: "cache-control", content: "no-cache" },
    { name: "expires", content: "0" },
    { name: "pragma", content: "no-cache" },
  ],

  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    DesktopSideBar,
  },
  mounted() {    

  },
  created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
  },
  data() {
    return {
      token: null,
      showFloatingMenu: false,
      window: false,
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    hasAccess(menu) {
      return this.$store.getters['auth/hasAccess'](menu)
    },
    hasMenu(posicao) {        
        return this.$store.getters['auth/hasMenu'](posicao)
    },
    isTela(v) {
      return this.$route.name === v
    },
    handleResize() {
        this.window = window.innerWidth;
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },
  },

};

function limparCacheJS() {
  try {
    caches.keys().then(function (keyList) {
      return Promise.all(
        keyList.map(function (key) {
          if (key.indexOf("escala-medica") !== -1) {
            console.log(key);
            caches.open(key).then((cache) =>
              cache.keys().then((keys) => {
                for (let entry of keys) {
                  if (entry.url.indexOf("index.html") !== -1) {
                    console.log(entry);
                    cache.delete(entry);
                  }
                }
              })
            );
          }
        })
      );
    });
  } catch (e) {
    console.log("Falha ao limpar cache");
    console.log(e);
  }
}
</script>

<style scoped>
@media (min-width: 0px) {
  .main-panel-mobile {
    width: 100%;
    margin-top: 4em;
    display: block;
  }

  .desktop {
    display: none;
  }

  .main-panel {
    display: none;
  }
}

@media (min-width: 990px) {
  .main-panel-mobile {
    display: none;
  }

  .desktop {
    display: block;
  }

  .main-panel {
    display: block;
  }
}

.dropdown-container {
  display: flex;
  justify-content: center;
  width: 3em;
  line-height: 31px;
}

.dropdown-container:hover {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}

.dropdown-container i {
    font-size: 28px;
    color: #fff;
    opacity: .86;
}

.dropbtn {
  color: white;
  font-size: 16px;
  margin: 0;
  padding: 0;
  border: none;
}

.dropdown {
  position: relative;
  margin: 0;
  padding: 1em 1em;
  display: flex;
  transition: 0.2s;
  z-index: 999 !important;
}

.dropdown-content {
  display: none;
  position: absolute;
  left: 3.3em;
  
  /* top: -0.04em; */
  top: 0;
  background-color: #4781ff;
  min-height: 100%;
  /* min-width: 160px; */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 999 !important;
}

.dropdown-content p {
  width: 10em;
  padding: 12px 16px 0 16px;
  font-weight: bold;
}

.dropdown-content a {
  color: #fff;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  left: 50px;
}

.dropdown-content a:hover {
  background-color: #2f6aeb;
}

.dropdown:hover .dropdown-content {
  display: block;
}

</style>
